import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxChartsModule } from '@stoick/ngx-15-charts';
import { MaterialModule } from '../common-modules/material.module';
import { SharedModule } from '../shared/shared.module';
import { PrintPageComponent } from './print-page.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { TooltipComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, SankeyChart } from "echarts/charts";
import * as echarts from 'echarts/core';
import { TranslateModule } from '@ngx-translate/core';
import { PrintMpgElementsLandscapeComponent } from './print-page-landscape/print-mpg-elements-landscape/print-mpg-elements-landscape.component';
import { PrintMpgLandscapeComponent } from './print-page-landscape/print-mpg-landscape/print-mpg-landscape.component';
import { PrintExtraIndicatorLandscapeComponent } from './print-page-landscape/print-extra-indicator-landscape/print-extra-indicator-landscape.component';
import { PrintCombinationBuildingDetailsComponent } from './print-page-landscape/print-combination-building-details/print-combination-building-details.component';
import { PrintFirstPageHeaderComponent } from './print-page-landscape/print-first-page-header/print-first-page-header.component';


echarts.use([BarChart, SankeyChart, CanvasRenderer, TooltipComponent]);


@NgModule({
    declarations: [PrintPageComponent, PrintMpgElementsLandscapeComponent, PrintMpgLandscapeComponent, PrintExtraIndicatorLandscapeComponent, PrintCombinationBuildingDetailsComponent, PrintFirstPageHeaderComponent],
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule,
        MaterialModule,
        NgxChartsModule,
        NgxEchartsModule.forRoot({ echarts })
    ]
})
export class PrintPageModule { }
